import {CUSTOM_SECTIONS_ID} from '../../../consts/customSectionsId';
import {isCustomSectionVisible} from '../../../utils/isCustomSectionVisible';

export function getActiveCustomSections() {
  return CUSTOM_SECTIONS_ID.filter((section) => isCustomSectionVisible(section));
}
